// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1827":"d6d72da581bb9bba","3404":"06f619f025d3ec55"}[chunkId] + ".js";
};